import { AnimationAction, AnimationClip, AnimationMixer, LoopOnce } from "three";
import { IPlayerAnimationConfiguration } from "../scenes/game/components/3d/character/animations/configurations/IPlayerAnimationConfiguration";

export class AnimationParsingUtils {
    public static animationActionByName(mixer: AnimationMixer, animations: Array<AnimationClip>, name: string): AnimationAction {
        return AnimationParsingUtils.configDefaultAction(mixer.clipAction(animations.find((clip) => clip.name == name)));
    }

    public static animationActionByCondition(mixer: AnimationMixer, animations: Array<AnimationClip>, condition: (clip: AnimationClip) => boolean): Array<AnimationAction> {
        return animations
            .filter((clip) => condition(clip))
            .map((clip) => AnimationParsingUtils.configDefaultAction(mixer.clipAction(clip)));
    }

    public static configDefaultAction(action: AnimationAction): AnimationAction {
        action.loop = LoopOnce;
        action.clampWhenFinished = true;
        return action;
    }

    public static applyConfigurationToAction(action: AnimationAction, configuration: IPlayerAnimationConfiguration): void {
        action.timeScale = configuration.timeScale;
    }
}
